import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { DateTime } from 'luxon';

/**
 * @customElement logistik-page-order-evaluation
 */
@customElement('logistik-page-order-evaluation')
export class LogistikPageOrderEvaluation extends ChemistryLitElement {
  override render() {
    return html`
      <logistik-component-base-page-layout>
        <logistik-component-base-header
          pageTitle="Auswertung"
          pageDescription="Hier können Auswertungen gefiltert und exportiert werden."
        ></logistik-component-base-header>
        ${this._content()}
      </logistik-component-base-page-layout>
    `;
  }

  private _content() {
    return html`
      <cr-card>
        <cr-flex space="md">
          <cr-button
            href="/__export/hefte/${DateTime.now().toFormat('yyyy.LL.dd') + '_Bestellungen.csv'}"
            target="_blank"
          >
            Bestellungen exportieren
          </cr-button>
        </cr-flex>
      </cr-card>
    `;
  }
}
